var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"bg-custom border-custom",on:{"click":function($event){return _vm.$emit('refresh')}}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"sync-alt"}}),_vm._v(" "+_vm._s(_vm.$t("filter.apply"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }